import auth from "@/router/middleware/auth";
import permission from "@/router/middleware/permission";

export default [
//******* Roles *******
    {
        path: '/system/roles',
        name: 'system.roles',
        meta: {middleware: [auth, permission], permission: 'system_roles_list'},
        component: () => import('../views/system/roles/list'),
    },
    {
        path: '/system/roles/create',
        name: 'system.roles.create',
        meta: {middleware: [auth, permission], permission: 'system_roles_create'},
        component: () => import('../views/system/roles/create')
    },
    {
        path: '/system/roles/edit/:id',
        name: 'system.roles.edit',
        meta: {middleware: [auth, permission], permission: 'system_roles_edit'},
        component: () => import('../views/system/roles/edit')
    },
//******* Users *******
    {
        path: '/system/users',
        name: 'system.users',
        meta: {middleware: [auth, permission], permission: 'system_users_list'},
        component: () => import('../views/system/users/index'),
    },
    {
        path: '/system/users/create',
        name: 'system.users.create',
        meta: {middleware: [auth, permission], permission: 'system_users_create'},
        component: () => import('../views/system/users/create')
    },
    {
        path: '/system/users/edit/:id',
        name: 'system.users.edit',
        meta: {middleware: [auth, permission], permission: 'system_users_edit'},
        component: () => import('../views/system/users/edit')
    }
]